<template>
  <thead class="vst-header">
    <tr class="vst-header-row">
      <th
        v-for="(header, idx) in headers"
        :key="header.value"
        class="vst-header-cell"
        :class="getHeaderClass(header, idx)"
        :style="idx < realFixedColsCount ? { left: (idx < fixedColsCount ? realStickyOffsets[idx] : stickyOffsets[idx]) + 'px' } : {}"
        @click="onClickCell(header)"
      >
        <v-hover v-slot="{ hover }">
          <div class="vst-header-content" :class="{ 'pl-7': hasHeaderPadding(idx) }">
            <slot :name="`header.${header.value}`" :value="header.value" :header="header">
              <span>{{ header.text }}</span>
            </slot>
            <v-icon
              v-if="Object.hasOwn(header, 'sortable') ? header.sortable : true"
              :style="{ visibility: hover || isActive(header) ? 'visible' : 'hidden' }"
              :class="{ rotate: direction(header) }"
              class="toggleUpDown"
              size="16"
            >
              mdi-chevron-down
            </v-icon>
          </div>
        </v-hover>
      </th>
    </tr>
  </thead>
</template>

<script>
export default {
  name: 'VSTHeader',
  props: {
    headers: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    realFixedColsCount: {
      type: Number,
      required: true,
    },
    fixedColsCount: {
      type: Number,
      required: true,
    },
    realStickyOffsets: {
      type: Array,
      required: true,
    },
    stickyOffsets: {
      type: Array,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    openedGroups: {
      type: Array,
      default: () => [],
    },
    openedSubGroups: {
      type: Array,
      default: () => [],
    },
    headersWithChildCount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    hasHeaderPadding(idx) {
      return (
        this.headersWithChildCount - 1 > idx &&
        (idx === 0 || (this.openedGroups.length && idx === 1) || (this.openedSubGroups.length && idx === 2))
      )
    },
    isActive(header) {
      return this.options.sortBy?.length && this.options.sortBy.includes(header.value)
    },
    direction(header) {
      return this.isActive(header) && this.options.sortDesc?.[0]
    },
    onClickCell(header) {
      if (Object.hasOwn(header, 'sortable') ? header.sortable : true) {
        const sortOptions = {
          sortBy: [header.value],
          sortDesc: [this.isActive(header) ? !this.options.sortDesc[0] : false],
        }
        this.$emit('update-options', {
          ...this.options,
          ...sortOptions,
        })
      }
    },
    getHeaderClass(header, idx) {
      return [
        header.class,
        header.align && `text-${header.align}`,
        (Object.hasOwn(header, 'sortable') ? header.sortable : true) && 'cursor-pointer',
        { 'vst-sticky': idx < this.realFixedColsCount },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.vst-header {
  .vst-header-row {
    height: 40px;
  }

  .vst-header-cell {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #fff;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    padding: 0 8px;
    text-align: left;
    white-space: nowrap;

    &.vst-sticky {
      z-index: 11;
    }

    .vst-header-content {
      display: flex;
      align-items: center;
      gap: 4px;

      .toggleUpDown {
        transition: transform 0.2s;
        &.rotate {
          transform: rotate(180deg);
        }
      }
    }
  }
}
</style>
